<template>
  <footer class="site-footer">
    <div class="footer-container container">
      <div class="footer-main">
        <section class="footer-brand" aria-labelledby="footer-brand-title">
          <div class="footer-logo">
            <img :src="logoImage" alt="Nivi" />
          </div>
          <h2 id="footer-brand-title" class="footer-title">Nivi</h2>
          <p class="footer-desc">
            AI情感陪伴机器人，融合法式优雅与东方哲学，用科技传递温暖，让每个生命都被温柔以待。
          </p>
          <div class="social-icons" v-if="socialIcons.length > 0">
            <a
              v-for="(icon, index) in socialIcons"
              :key="index"
              :href="icon.url"
              :title="icon.title"
              class="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img v-if="icon.image" :src="icon.image" :alt="icon.title" />
              <i v-else :class="icon.iconClass"></i>
            </a>
          </div>
          <!-- 默认社交图标 -->
          <div class="social-icons" v-else>
            <a href="#" class="social-icon" title="微信">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178A1.17 1.17 0 014.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178 1.17 1.17 0 01-1.162-1.178c0-.651.52-1.18 1.162-1.18zm3.2 4.127c-3.997 0-7.242 2.697-7.242 6.03 0 3.334 3.245 6.03 7.242 6.03.726 0 1.424-.104 2.076-.282a.624.624 0 01.516.07l1.37.8a.234.234 0 00.12.04.212.212 0 00.209-.213c0-.052-.02-.103-.034-.154l-.281-1.064a.426.426 0 01.153-.478c1.378-1.014 2.27-2.548 2.27-4.249 0-3.333-3.245-6.03-7.242-6.03h-.157zm-2.347 3.395c.463 0 .838.381.838.85a.844.844 0 01-.838.85.844.844 0 01-.838-.85c0-.469.376-.85.838-.85zm4.693 0c.463 0 .838.381.838.85a.844.844 0 01-.838.85.844.844 0 01-.838-.85c0-.469.376-.85.838-.85z"/>
              </svg>
            </a>
            <a href="#" class="social-icon" title="微博">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M10.098 20.323c-3.977.391-7.414-1.406-7.672-4.02-.259-2.609 2.759-5.047 6.74-5.441 3.979-.394 7.413 1.404 7.671 4.018.259 2.6-2.759 5.049-6.739 5.443zm-1.405-7.498c-2.623.268-4.586 1.949-4.387 3.756.199 1.808 2.473 3.012 5.096 2.744 2.623-.268 4.586-1.949 4.387-3.756-.199-1.808-2.473-3.012-5.096-2.744zM20.196 9.4a5.07 5.07 0 00-1.958-.478c-.233-.025-.439-.189-.439-.424s.206-.399.439-.424a5.07 5.07 0 001.958-.478c.658-.293 1.038-.778 1.038-1.296 0-.518-.38-1.003-1.038-1.296a5.07 5.07 0 00-1.958-.478c-.233-.025-.439-.189-.439-.424s.206-.399.439-.424a5.07 5.07 0 001.958-.478c.658-.293 1.038-.778 1.038-1.296 0-.518-.38-1.003-1.038-1.296a5.07 5.07 0 00-1.958-.478c-.233-.025-.439-.189-.439-.424s.206-.399.439-.424a5.07 5.07 0 001.958-.478c.658-.293 1.038-.778 1.038-1.296 0-.518-.38-1.003-1.038-1.296"/>
              </svg>
            </a>
            <a href="#" class="social-icon" title="抖音">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.46V13a8.28 8.28 0 005.58 2.16V11.7a4.83 4.83 0 01-3.77-1.24V6.69h3.77z"/>
              </svg>
            </a>
            <a href="#" class="social-icon" title="小红书">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4.5 13.5h-9a1 1 0 01-1-1v-7a1 1 0 011-1h9a1 1 0 011 1v7a1 1 0 01-1 1zm-7-6.5v5h2v-5h-2zm3 0v5h2v-5h-2z"/>
              </svg>
            </a>
          </div>
        </section>

        <section class="footer-contact" aria-labelledby="footer-contact-title">
          <h3 id="footer-contact-title" class="footer-section-title">联系 Nivi</h3>
          <ul class="contact-list">
            <li>
              <span class="contact-label">邮箱</span>
              <a class="contact-value" :href="`mailto:${contactEmail}`">{{ contactEmail }}</a>
            </li>
            <li>
              <span class="contact-label">电话</span>
              <a class="contact-value" :href="`tel:${contactPhone}`">{{ contactPhone }}</a>
            </li>
            <li>
              <span class="contact-label">地址</span>
              <span class="contact-value">{{ companyAddress }}</span>
            </li>
          </ul>

          <div class="footer-shortcuts">
            <router-link
              v-for="link in shortcutLinks"
              :key="link.id"
              :to="link.url"
              class="footer-shortcut"
            >
              {{ link.title }}
            </router-link>
          </div>
        </section>

        <section class="footer-records" aria-labelledby="footer-records-title">
          <h3 id="footer-records-title" class="footer-section-title">备案与版权</h3>
          <div class="record-list">
            <p class="record-item">
              <a
                class="record-link"
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ icpNumber || '粤ICP备2026105164号' }}
              </a>
            </p>
            <p class="record-item">{{ companyAddress }}</p>
            <p class="record-item">© {{ currentYear }} Nivi. All Rights Reserved.</p>
          </div>
        </section>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import logoImage from '@/assets/images/logo/nivi-logo.png'

const confirmedCompanyAddress = '深圳市龙华区环智中心 A 座 4 楼'

export default {
  name: 'SiteFooter',
  data() {
    return {
      currentYear: new Date().getFullYear(),
      contactEmail: 'nivi001@yeah.net',
      contactPhone: '4006586196',
      companyAddress: confirmedCompanyAddress,
      icpNumber: '粤ICP备2026105164号',
      logoImage
    }
  },
  computed: {
    ...mapGetters('button', ['footerLinkList', 'socialIconList']),
    socialIcons() {
      return this.socialIconList || []
    },
    footerLinks() {
      return this.footerLinkList || []
    },
    shortcutLinks() {
      const dynamicLinks = this.footerLinks.filter(link => link.parentId && link.parentId > 0)
        .map(link => ({ id: link.id, title: link.title, url: link.url }))

      if (dynamicLinks.length > 0) {
        return dynamicLinks
      }

      return [
        { id: 'products-children', title: 'Nivi蛋', url: '/products/children' },
        { id: 'about', title: '公司简介', url: '/about' },
        { id: 'news', title: '新闻动态', url: '/news' },
        { id: 'contact', title: '联系我们', url: '/about#contact' },
        { id: 'cooperation-channel', title: '渠道代理', url: '/cooperation' },
        { id: 'cooperation-brand', title: '品牌联名', url: '/cooperation' }
      ]
    }
  },
  mounted() {
    this.$store.dispatch('button/fetchButtonList', 'footer')
    this.$store.dispatch('button/fetchButtonList', 'social')
  }
}
</script>

<style lang="scss" scoped>
.site-footer {
  background-color: $color-text;
  color: rgba($color-text-white, 0.75);
  padding: $spacing-4xl 0;
}

.footer-container {
  width: 100%;
}

.footer-main {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 0.9fr);
  gap: $spacing-2xl;
  align-items: start;

  @include respond-to('lg') {
    grid-template-columns: 1fr;
    gap: $spacing-2xl;
  }
}

.footer-title,
.footer-section-title {
  color: $color-text-white;
  letter-spacing: 0;
}

.footer-title {
  font-size: $font-size-xl;
  margin-bottom: $spacing-sm;
}

.footer-section-title {
  font-size: $font-size-md;
  margin-bottom: $spacing-lg;
}

.footer-brand {
  .footer-logo {
    display: flex;
    align-items: center;
    margin-bottom: $spacing-md;

    img {
      width: 108px;
      height: 68px;
      object-fit: contain;
    }
  }

  .footer-desc {
    font-size: $font-size-sm;
    line-height: $line-height-loose;
    color: rgba($color-text-white, 0.6);
    max-width: 420px;
    margin-bottom: $spacing-xl;
  }
}

.social-icons {
  display: flex;
  flex-wrap: wrap;
  gap: $spacing-md;
}

.social-icon {
  width: $touch-target-min;
  height: $touch-target-min;
  border-radius: $radius-full;
  background-color: rgba(255, 255, 255, 0.08);
  @include flex-center;
  color: rgba($color-text-white, 0.7);
  transition: all $transition-base;

  &:hover {
    background-color: $color-primary;
    color: $color-text-white;
    transform: translateY(-2px);
  }

  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
}

.footer-contact,
.footer-records {
  display: flex;
  flex-direction: column;
}

.contact-list,
.record-list {
  display: grid;
  gap: $spacing-md;
}

.contact-list li,
.record-item {
  display: grid;
  gap: $spacing-xs;
  color: rgba($color-text-white, 0.7);
}

.contact-label {
  font-size: $font-size-xs;
  color: rgba($color-text-white, 0.45);
  text-transform: uppercase;
  letter-spacing: 1.2px;
}

.contact-value,
.record-link {
  font-size: $font-size-sm;
  color: $color-text-white;
  line-height: $line-height-base;

  &:hover {
    color: $color-secondary;
  }
}

.footer-shortcuts {
  display: flex;
  flex-wrap: wrap;
  gap: $spacing-sm;
  margin-top: $spacing-xl;
}

.footer-shortcut {
  display: inline-flex;
  align-items: center;
  min-height: $touch-target-min;
  padding: 0 16px;
  border-radius: $radius-full;
  font-size: $font-size-sm;
  color: rgba($color-text-white, 0.72);
  background-color: rgba(255, 255, 255, 0.06);
  transition: background-color $transition-fast, color $transition-fast;

  &:hover {
    color: $color-secondary;
    background-color: rgba(255, 255, 255, 0.1);
  }
}

.record-item {
  font-size: $font-size-sm;
  color: rgba($color-text-white, 0.58);

  &:last-child {
    color: rgba($color-text-white, 0.42);
  }
}
</style>
